import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { AdapterRegistry, IModel, Metamodel, RestBasedServiceAuthenticationType } from 'shell-models-lib';
import { Model } from 'app/model/backendmodel';
import {
    parameterizablePasswordOrAKVtoSecretBase,
    parameterizableSecretBaseToModel
} from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { ZendeskLinkedService } from 'app/model/linkedservice/zendesk.linkedservice';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ZendeskLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                url: '*',
                authenticationType: '*',
                userName: '*',
                password: 'secret',
                apiToken: 'secret'
            },
            parameters: '*'
        }
    }
})
export class ZenDeskLinkedServiceAdapter extends LinkedServiceAdapter<ZendeskLinkedService> {
    protected supportFirstClassParameterExperience = true;

    protected modelConstructor(): new () => ZendeskLinkedService {
        return ZendeskLinkedService;
    }

    protected model(): IModel {
        return ZendeskLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: ZendeskLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.ZendeskLinkedService;
        properties.type = this.model().name;
        if (linkedService.authenticationType === RestBasedServiceAuthenticationType.BASIC) {
            properties.typeProperties = {
                url: this.valueToResource(linkedService, ZendeskLinkedService.URL),
                authenticationType: linkedService.authenticationType,
                userName: this.valueToResource(linkedService, ZendeskLinkedService.USER_NAME),
                password: parameterizablePasswordOrAKVtoSecretBase(linkedService, ZendeskLinkedService.PASSWORD, this.context)
            };
        } else if (linkedService.authenticationType === RestBasedServiceAuthenticationType.TOKEN) {
            properties.typeProperties = {
                url: this.valueToResource(linkedService, ZendeskLinkedService.URL),
                authenticationType: linkedService.authenticationType,
                apiToken: parameterizablePasswordOrAKVtoSecretBase(linkedService, ZendeskLinkedService.API_TOKEN, this.context)
            };
        }
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: ZendeskLinkedService): Promise<ZendeskLinkedService> {
        const properties = linkedServiceResource.properties as Model.ZendeskLinkedService;
        const typeProperties = properties.typeProperties;
        ValueAdapter.toModel(linkedService, ZendeskLinkedService.URL, typeProperties.url);
        linkedService.authenticationType = typeProperties.authenticationType as RestBasedServiceAuthenticationType;
        if (linkedService.authenticationType === RestBasedServiceAuthenticationType.BASIC) {
            ValueAdapter.toModel(linkedService, ZendeskLinkedService.USER_NAME, typeProperties.userName);
            parameterizableSecretBaseToModel(linkedService, ZendeskLinkedService.PASSWORD, typeProperties.password, this.context);
        } else if (linkedService.authenticationType === RestBasedServiceAuthenticationType.TOKEN) {
            parameterizableSecretBaseToModel(linkedService, ZendeskLinkedService.API_TOKEN, typeProperties.apiToken, this.context);
        }
        return linkedService;
    }
}
